<template>
    <div>
        <h4 class="text-uppercase">Xylella BESMETTE GEBIEDEN</h4>
        <div class="mt-4 p-4" style="background: #f7f7f7 0% 0% no-repeat padding-box">
            <form class="form-inline justify-content-center align-items-center" @click.prevent>
                <gmap-autocomplete
                    class="form-control mr-sm-5"
                    placeholder="Zoek op postcode of plaats"
                    @place_changed="setPlace"
                    style="min-width: 70%"
                    :options="{fields: ['geometry','formatted_address', 'name']}"
                >
                </gmap-autocomplete>
                <button type="submit" class="btn btn-primary btn-caret mt-2 mt-lg-0">Submit</button>
            </form>
            
        </div>
        <div style="min-height: 400px; width: 100%">
            <gmap-map ref="map" :center="center" :zoom="zoom" style="width: 100%; height: 600px">
                <gmap-info-window 
                    :position="infoWindowPos" 
                    :opened="infoWinOpen" 
                    :options="{pixelOffset: {width: 0, height: -35}}"
                    @closeclick="infoWinOpen=false"
                >
                    <p class="font-weight-bold">{{infoContent}}</p>
                </gmap-info-window>
                <gmap-marker
                    v-if="this.place"
                    label="★"
                    :position="{
                        lat: this.place.geometry.location.lat(),
                        lng: this.place.geometry.location.lng(),
                    }"   
                >
                </gmap-marker>
                <gmap-marker
                    :key="index"
                    v-for="(m, index) in locationMarkers"
                    :position="{'lat': parseFloat(m.latitude), 'lng':parseFloat(m.longitude)}"
                    @click="markerClick(m)"
                    :clickable="true"
                    :icon="markerOpts"
                ></gmap-marker>
                <gmap-circle
                    :key="index+'circle'"
                    v-for="(m, index) in locationMarkers"
                    :radius="m.radius"
                    :center="{'lat': parseFloat(m.latitude), 'lng':parseFloat(m.longitude)}"
                    :options="circleOptions"
                >
                </gmap-circle>
            </gmap-map>
        </div>

        <div class="mt-2">
            <div class="row">
                <div class="col-6">
                    <p class="text-uppercase text-purple font-weight-bold">BRONVERMELDING</p>
                </div>
                <div class="col-6 text-right">
                    <p class="font-weight-bold text-purple">Laatste update:</p>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-sm">
                    <tbody>
                        <tr
                            v-for="m,index in locationMarkers"
                            :key="index+'source'"
                        >
                            <td colspan="2" class="pl-2">{{ m.source }}</td>
                            <td class="text-right pr-2">{{ formatDate(m.updated_at) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import * as dayjs from "dayjs";

export default {
    data() {
        return {
            center: { 
                lat: 54.570,
                lng: 6.428
            },
            zoom: 4.25,
            locationMarkers: [],
            circleOptions: {
                strokeColor: '#800080',
                strokeOpacity: 1,
                strokeWeight: 1,
                fillColor: '#80068019'
            },
            place: null,
            infoWindowPos: null,
            infoWinOpen: null,
            infoContent: null,
            markerOpts: {
                url: 'theme/img/marker.png',
                scaledSize: {width: 30, height: 45, f: 'px', b: 'px',},
            }
        };
    },
    mounted() {
        this.locateGeoLocation();
        this.getInfectedLocations();
    },
    methods: {
        locateGeoLocation() {
             if(navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((res) => {
                    this.$refs.map.$mapPromise.then((map) => {
                        this.zoom = 14;
                        map.panTo({lat: res.coords.latitude, lng: res.coords.longitude});
                    });
                });
            } else {
                console.log("Browser doesn't support Geolocation");
            }
        },
        getInfectedLocations(){
            this.axios.get('/xylella/infected').then(response => {
                  this.locationMarkers = response.data.locations;
            })
            .catch(error => {
                console.log(error);
            });
        },
        formatDate(value) {
            if (value) {
                return dayjs(String(value)).format("DD MMM YYYY");
            }
        },
        markerClick(marker) {
            var self = this;
            this.$refs.map.$mapPromise.then((map) => {
                        this.zoom = 14;
                        map.panTo({lat: res.coords.latitude, lng: res.coords.longitude});
                       self.center = {'lat': self.parseFloat(marker.latitude), 'lng': self.parseFloat(marker.longitude)};
            });
            this.infoWindowPos= {'lat': parseFloat(marker.latitude), 'lng':parseFloat(marker.longitude)};
            this.infoWinOpen = true;
            this.infoContent = marker.source;

        },
        setPlace(place) {
            this.place = place;
            var self = this;
            this.$refs.map.$mapPromise.then((map) => {
                        this.zoom = 14;
                        map.panTo({lat: res.coords.latitude, lng: res.coords.longitude});
                        self.center = {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    };
            });
           
            this.infoWindowPos = {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    };
            this.infoWinOpen =  true;
            this.infoContent =  place.formatted_address;
        }

    },
};
</script>